/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import IconButton, { IconButtonProps } from '@material-ui/core/IconButton';
import InputAdornment, {
  InputAdornmentProps,
} from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import useStyles from './TogglePasswordIconButton.style';

type TogglePasswordIconButtonProps = {
  showPassword: boolean;
  setShowPassword: (showPassword: boolean) => void;
  InputAdornmentProps?: InputAdornmentProps;
  IconButtonProps?: IconButtonProps;
};

const handleMouseDownPassword = (
  event: React.MouseEvent<HTMLButtonElement>
) => {
  event.preventDefault();
};

const TogglePasswordIconButton: React.FC<TogglePasswordIconButtonProps> = ({
  InputAdornmentProps: inputAdornmentProps,
  IconButtonProps: iconButtonProps,
  showPassword,
  setShowPassword,
}) => {
  const { togglePasswordIconButton } = useStyles();

  const handleClickShowPassword = (
    _event: React.MouseEvent<HTMLButtonElement>
  ) => {
    setShowPassword(!showPassword);
  };

  return (
    <InputAdornment position="end" {...inputAdornmentProps}>
      <IconButton
        aria-label="toggle password visibility"
        className={togglePasswordIconButton}
        onClick={handleClickShowPassword}
        onMouseDown={handleMouseDownPassword}
        edge="end"
        {...iconButtonProps}
      >
        {showPassword ? <Visibility /> : <VisibilityOff />}
      </IconButton>
    </InputAdornment>
  );
};

export default TogglePasswordIconButton;
